import { render, staticRenderFns } from "./PricingOptionCard.vue?vue&type=template&id=4ba1bc13&scoped=true&"
import script from "./PricingOptionCard.vue?vue&type=script&lang=ts&"
export * from "./PricingOptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./PricingOptionCard.vue?vue&type=style&index=0&id=4ba1bc13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1bc13",
  null
  
)

export default component.exports